import {registerPlugin} from "@capacitor/core";

interface SessionPlugin {
  read(options: {scope: string}): Promise<{token: string | null}>;
  write(options: {scope: string; token: string}): Promise<void>;
  clear(options: {scope: string}): Promise<void>;
  diagnostics(options: {userId: string | null; sessionId: string; screen: string; release: string; operation?: string}): Promise<void>;
}

export const nativeSession = registerPlugin<SessionPlugin>("SproutSession");
